import { render, staticRenderFns } from "./FormTaxRate.vue?vue&type=template&id=2d48ea7d&scoped=true&"
import script from "./FormTaxRate.vue?vue&type=script&lang=js&"
export * from "./FormTaxRate.vue?vue&type=script&lang=js&"
import style0 from "./FormTaxRate.vue?vue&type=style&index=0&id=2d48ea7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48ea7d",
  null
  
)

export default component.exports